"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDataCloudTableType = exports.isCatalogTableType = void 0;
function isCatalogTableType(table) {
    return table.__typename === 'DatabaseTable';
}
exports.isCatalogTableType = isCatalogTableType;
function isDataCloudTableType(table) {
    return (table.tableType === 'DATALAKE'
        || table.tableType === 'DATAMODEL'
        || table.tableType === 'CALCULATEDINSIGHT');
}
exports.isDataCloudTableType = isDataCloudTableType;
//# sourceMappingURL=TablesDisplayPlacePageData.js.map